import React, { useState } from 'react';
import './Microtransactions.css';

interface MicrotransactionsProps {
  isOpen: boolean;
  onClose: () => void;
  shinyRocks: number;
  onBuyShinyRocks: () => void;
  shinyUpgrades: {
    parentValidation: number;
    overpricedCoffee: number;
  };
  onUpgrade: (type: 'parentValidation' | 'overpricedCoffee') => void;
}

const Microtransactions: React.FC<MicrotransactionsProps> = ({
  isOpen,
  onClose,
  shinyRocks,
  onBuyShinyRocks,
  shinyUpgrades,
  onUpgrade,
}) => {
  const [showThanks, setShowThanks] = useState(false);

  if (!isOpen) return null;

  const getUpgradeCost = (level: number) => 100;
  const maxLevel = 10;

  const handleBuyClick = () => {
    onBuyShinyRocks();
    setShowThanks(true);
  };

  const handleThanksClose = () => {
    setShowThanks(false);
  };

  return (
    <div className="micro-overlay" onClick={onClose}>
      <div className="micro-popup" onClick={(e) => e.stopPropagation()}>
        <button className="micro-close-button" onClick={onClose}>×</button>

        <div className="micro-header">
          <h2 className="micro-title">Microtransactions</h2>
          <p className="micro-subtitle">
            Trade real money for imaginary rocks. What could possibly go wrong?
          </p>
          <p className="micro-balance">
            SHINY ROCKS: <span className="micro-balance-value">{shinyRocks}</span> 💎
          </p>
        </div>

        <div className="micro-content">
          <div className="micro-section">
            <h3 className="micro-section-title">Buy SHINY ROCKS</h3>
            <p className="micro-section-description">
              Purchase <strong>1000 SHINY ROCKS</strong> for <strong>$1.00</strong> via Stripe/Revolut.
            </p>
            <button className="micro-buy-button" onClick={handleBuyClick}>
              Buy 1000 SHINY ROCKS – $1.00
            </button>
            <p className="micro-note">
              Note: In a real deployment, this button should redirect to a Stripe/Revolut Checkout link
              and only grant SHINY ROCKS after successful payment confirmation.
            </p>
          </div>

          <div className="micro-section">
            <h3 className="micro-section-title">Spend SHINY ROCKS</h3>

            <div className="micro-upgrade">
              <div className="micro-upgrade-info">
                <h4>Parent Validation</h4>
                <p>Makes you feel like your career choices were correct. Does nothing mechanically.</p>
                <p className="micro-upgrade-level">
                  Level {shinyUpgrades.parentValidation}/{maxLevel}
                </p>
              </div>
              <button
                className="micro-upgrade-button"
                onClick={() => onUpgrade('parentValidation')}
                disabled={
                  shinyUpgrades.parentValidation >= maxLevel ||
                  shinyRocks < getUpgradeCost(shinyUpgrades.parentValidation)
                }
              >
                {shinyUpgrades.parentValidation >= maxLevel
                  ? 'MAX LEVEL'
                  : `Buy (${getUpgradeCost(shinyUpgrades.parentValidation)} 💎)`}
              </button>
            </div>

            <div className="micro-upgrade">
              <div className="micro-upgrade-info">
                <h4>Overpriced Coffee</h4>
                <p>Artisanal sadness in a cup. Also does nothing, but you feel oddly worse.</p>
                <p className="micro-upgrade-level">
                  Level {shinyUpgrades.overpricedCoffee}/{maxLevel}
                </p>
              </div>
              <button
                className="micro-upgrade-button"
                onClick={() => onUpgrade('overpricedCoffee')}
                disabled={
                  shinyUpgrades.overpricedCoffee >= maxLevel ||
                  shinyRocks < getUpgradeCost(shinyUpgrades.overpricedCoffee)
                }
              >
                {shinyUpgrades.overpricedCoffee >= maxLevel
                  ? 'MAX LEVEL'
                  : `Buy (${getUpgradeCost(shinyUpgrades.overpricedCoffee)} 💎)`}
              </button>
            </div>
          </div>
        </div>

        {showThanks && (
          <div className="micro-thanks-overlay" onClick={handleThanksClose}>
            <div className="micro-thanks-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Bro I would never ask money from you 🥺</h3>
              <p>
                I just gave you <strong>1000 SHINY ROCKS</strong> for free.
              </p>
              <p>
                If you really, really want to support me anyway, you can send something to{' '}
                <a
                  href="https://revolut.me/matvejolm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  revolut.me/matvejolm4
                </a>.
              </p>
              <button className="micro-thanks-button" onClick={handleThanksClose}>
                Thanks, bro ❤️
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Microtransactions;


